import styled from "styled-components";

export const StyledFooter = styled.div`
  .bottom {
    width: 1000px;
    font: 12px Microsoft JhengHei, arial;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin: 40px auto 0;
  }

  .logos {
    width: 180px;
    height: 45px;
    display: flex;
    margin: 0 auto 20px;
    background: url("https://cdngarenanow-a.akamaihd.net/games/lol/2020/LOLwebsite/img/footer/logos.png")
      no-repeat center 0%;
  }

  .cnt {
    flex: 1;
    text-align: left;
  }

  .social-links {
    margin-top: 30px;
    text-align: center;
  }

  .playForFree {
    color: #1398e6;
    width: 180px;
    height: 50px;
    line-height: 52px;
    font-size: 16px;
    font-weight: 600;
    display: inline-block;
    background: url("https://cdngarenanow-a.akamaihd.net/web/image/lol/landing-dominion/WEBSITE/img/footer/playForFree.png")
      no-repeat;
    background-size: contain;
    vertical-align: middle;
  }

  .links {
    padding: 6px 0;
    font-size: 15px;
    font-weight: 600;
    display: inline-block;
    vertical-align: sub;
    margin-top: 20px;
  }

  .link {
    color: white;
    display: inline-flex;
    align-items: center;
    flex: 1 1 auto;
    padding: 0 10px;
    position: relative;
    box-sizing: border-box;
    font-family: footericon;
    cursor: pointer;
  }

  .link::before {
    content: "\\e900";
    font-size: 1.3em;
    font-family: footericon;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    margin: 0 5px 0 0;
  }

  .link:nth-child(2)::before {
    content: "\\e904";
  }

  .link:nth-child(3)::before {
    content: "\\e901";
  }

  .link:nth-child(4)::before {
    content: "\\e902";
  }

  .link:last-child::after {
    display: none;
  }

  .link-txt {
    font-size: 10px;
  }

  @media screen and (max-width: 750px) {
    .playForFree {
      display: none;
    }
  }
`;
